import { z } from 'zod';

/** Events the API records itself. Never accepted from the browser. */
export const SERVER_PRODUCT_EVENTS = [
  'inventory_searched',
  'plan_refused',
  'match_refused_no_signal',
  'file_download_signed',
] as const;

/** Events the SPA beacons (POST /v1/projects/:projectId/events). */
export const CLIENT_PRODUCT_EVENTS = [
  'tab_viewed',
  'setup_step_entered',
  'setup_step_left',
  'setup_step_skipped',
  'location_pack_printed',
] as const;

export const PRODUCT_EVENT_NAMES = [...SERVER_PRODUCT_EVENTS, ...CLIENT_PRODUCT_EVENTS] as const;
export type ProductEventName = (typeof PRODUCT_EVENT_NAMES)[number];

const PropValue = z.union([z.string().max(500), z.number(), z.boolean(), z.null()]);

export const ClientProductEvent = z
  .object({
    eventId: z.uuid(),
    eventName: z.enum(CLIENT_PRODUCT_EVENTS),
    clientOccurredAt: z.iso.datetime(),
    sessionId: z.uuid(),
    pagePath: z.string().max(512).optional(),
    subjectType: z.string().max(64).optional(),
    subjectId: z.string().max(32).optional(),
    props: z.record(z.string().max(64), PropValue).refine((props) => Object.keys(props).length <= 20, 'at most 20 props'),
  })
  .strict();
export type ClientProductEventInput = z.infer<typeof ClientProductEvent>;

export const ProductEventBatch = z.object({ events: z.array(ClientProductEvent).min(1).max(50) }).strict();
